var _if = {
  exports: {}
};

export { _if as _ };
//# sourceMappingURL=if.js.map
